(() => {

  const sameTabPageButtons = () => {
    let selector;
    if (location.pathname === '/pages/contact-us') selector = 'main a.igcu-primary';
    if (location.pathname === '/pages/help-information-center') selector = 'main a.ighc-cta[href*="/pages/contact-us"]';
    if (!selector) return;
    document.querySelectorAll(selector).forEach(link => {
      const label = link.textContent.trim();
      if (label !== 'Find Answers Instantly' && label !== 'Contact Customer Support') return;
      if (link.getAttribute('target') !== '_self') link.setAttribute('target', '_self');
    });
  };
  const label = root => {
    const journeyPath = decodeURIComponent(location.pathname);
    const journeyButtonSelectors = {
      '/pages/savings-rewards': '.igsg-next-step a.igsg-primary-button',
      '/pages/💰-unlock-savings-rewards': '.igsg-next-step a.igsg-primary-button',
      '/pages/🏷️-savings-rewards-2-0': '.igsg-next-step a.igsg-primary-button',
      '/pages/savings-rewards-faqs': '.igsg-completion a.igsg-secondary-button'
    };
    const journeyButtonSelector = journeyButtonSelectors[journeyPath];
    if (journeyButtonSelector) document.querySelectorAll(journeyButtonSelector).forEach(link => {
      if (link.target !== '_self') link.target = '_self';
    });

    if (location.pathname === '/pages/savings-rewards-knowledge-center') {
      const account = document.querySelector('.igsg-cta-wrap a.igsg-primary-button');
      if (account && account.textContent.trim() === 'Create Your Free Account') {
        if (account.target !== '_self') account.target = '_self';
        if (!document.getElementById('ig-journey-restart')) {
          const offer = document.createElement('p');
          offer.id = 'ig-journey-restart';
          offer.append('Want to review the benefits once more? ');
          const link = document.createElement('a');
          link.className = 'ig-journey-restart-link';
          link.href = '/pages/savings-rewards';
          link.target = '_self';
          link.textContent = 'Take the Savings & Rewards journey again.';
          offer.append(link);
          const note = account.parentElement.querySelector('.igsg-small');
          (note || account).after(offer);
        }
      }
    }

    sameTabPageButtons();
    root.querySelectorAll('.klaviyo-favorites-plp-slot button').forEach(button => {
      if (!button.getAttribute('aria-label')) button.setAttribute('aria-label', 'Add to or remove from favorites');
    });
    root.querySelectorAll('a:has(img[alt="logo"])').forEach(link => link.setAttribute('aria-label', 'InspiredGrabs™ home'));
  };
  const start = () => {
    label(document);
    document.querySelectorAll('.mobile-submenu-label[role="button"]').forEach(control => control.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); control.click(); }
    }));
    let frame;
    const observer = new MutationObserver(records => {
      if (!records.some(record => record.addedNodes.length)) return;
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => label(document));
    });
    observer.observe(document.body, {childList: true, subtree: true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
